import { render } from "./ModalChooseClub.vue?vue&type=template&id=4b5a91b2&scoped=true&ts=true"
import script from "./ModalChooseClub.vue?vue&type=script&lang=ts"
export * from "./ModalChooseClub.vue?vue&type=script&lang=ts"

import "./ModalChooseClub.vue?vue&type=style&index=0&id=4b5a91b2&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5a91b2"]])

export default __exports__